<template>
  <div class="pendingPaymentInfo">
    <topTitle title="待付款详情"></topTitle>
    <div class="pendingtop">
      <div>
        <img src="../../assets/localImage/payment.png" alt />
      </div>
      <h2>等待买家付款</h2>
    </div>
    <addressReceiving :addressData="details"></addressReceiving>
    <div class="purchase">
      <div class="shopName">
        <p>
          订单号：{{details.sn}}
          <!-- <span class="r">交易成功</span> -->
        </p>
      </div>
      <div class="od_cont" v-for="(item,index) in details.order_sku_list" :key="index">
        <div class="od_cont_img">
          <img :src="item.goods_image" alt />
        </div>
        <div class="od_cont_xinxi">
          <h4 class="od_cont_name">
            <div class="l">{{item.name}}</div>
            <!-- <span class="r color-yellow">￥760/桶</span> -->
            <div class="r">
              <p>¥{{item.original_price}}</p>
              <p class="color-999" v-if="item.point!=null">重消币:¥{{item.point}}</p>
            </div>
          </h4>
          <h4 class="od_cont_font">
            <p>数量：x{{item.num}}</p>
          </h4>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="item">
        <div>配送方式</div>
        <div>快递运输</div>
      </div>
      <div class="item">
        <div>发票</div>
        <div>
          普通
          <span class="color-js">电子</span> 发票（个人）
        </div>
      </div>
      <div class="item">
        <div>运费</div>
        <div>¥{{details.shipping_price}}</div>
      </div>
      <div class="item">
        <div>重消币</div>
        <div class="color-js" v-if="details.use_point!=null&&details.use_point>personal.consum_point">余额不足</div>
        <div class="color-js" v-else>¥{{details.use_point==null?'0':details.use_point}}（余额：{{personal.consum_point}}）</div>
      </div>
      <div class="item">
        <div>实付款</div>
        <div class="color-js">¥{{details.order_price}}</div>
      </div>
    </div>
    <div class="p">选择支付方式：</div>
    <div class="list mt-0">
      <van-radio-group v-model="radio">
        <div class="item">
          <div class="wx">
            <img src="../../assets/localImage/weixinzhifu.png" alt />
            微信支付
          </div>
          <van-radio name="1"></van-radio>
        </div>
        <!-- <div class="item">
          <div class="zfb">
            <img src="../../assets/localImage/zhifubao.png" alt />
            支付宝支付
          </div>
          <van-radio name="2"></van-radio>
        </div> -->
      </van-radio-group>
    </div>

    <div class="pay">
      <p>
        合计：
        <span>¥{{details.order_price}}</span>
      </p>
      <button @click="qzf()">去支付</button>
    </div>
  </div>
</template>

<script>
import topTitle from "../../components/topTitle.vue";
import addressReceiving from "../../components/addressReceiving.vue";

import { Dialog } from "vant";
export default {
  name: "pendingPaymentInfo",
  data() {
    return {
      radio: "1",
      sn:this.$route.query.sn,
      details:{},
      personal:{}
    };
  },
  created(){
    this.getPersonal();
    this.getInfo();
  },
  components: {
    topTitle,
    addressReceiving
  },
  methods: {
    qzf(){
      console.log(this.details)
      this.$router.push({path:'orderPay',query:{
           sn:this.details.sn,
           order_price:this.details.order_price,
           type:'1'
			  }});
    },
    getPersonal(){
      this.getRequest( `members`).then(res => {
        console.log(res.data.data)
        this.personal =  res.data.data;
      })
    },
    getInfo(){
      this.getRequest( `trade/orders/${this.sn}`).then(res => {
        console.log(res.data.data)
        this.details =  res.data.data;
      })
    }
  }
};
</script>


<style scoped lang='less'>
.pendingPaymentInfo {
  .pendingtop {
    width: 100%;
    height: 180px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    h2 {
      font-size: 32px;
    }
    font-family: AlibabaPuHuiTiM;
    background: linear-gradient(to right, #ff9345, #fd5d46, #fd4843);
    > div {
      width: 101px;
      height: 101px;
      margin-right: 27px;
    }
  }
  .purchase {
    width: 94%;
    margin: 0 auto;
    background-color: white;
    margin-top: 20px;
    overflow: hidden;
    border-radius: 8px;
    .shopName {
      color: #333333;
      font-size: 26px;
      padding: 24px;
      .r {
        color: #ff1919;
        font-size: 26px;
      }
    }
    .od_cont {
      width: 100%;
      box-sizing: border-box;
      padding: 10px 24px;
      padding-bottom: 45px;
      overflow: hidden;
      .od_cont_img {
        width: 180px;
        height: 180px;
        overflow: hidden;
        float: left;
        border-radius: 8px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .od_cont_xinxi {
        width: 460px;
        height: 180px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        float: right;
        overflow: hidden;
        > h4 {
          line-height: 53px;
        }
        .od_cont_name {
          color: #333333;
          // line-height: 30px;
          .l {
              width: 280px;
              height: 90px;
              font-size: 26px;
              line-height: 44px;
              float: left;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
          .r {
            font-size: 24px;
            float: right;
            p {
              text-align: right;
            }
            line-height: 40px;
          }
        }

        .od_cont_font {
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 40px;
          color: rgba(153, 153, 153, 1);
          .color-js {
            font-size: 24px;
          }
        }
      }
    }
  }
  .p {
    height: 74px;
    line-height: 74px;
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(158, 158, 158, 1);
    padding-left: 32px;
  }
  .list {
    background: #ffffff;
    margin-top: 20px;
    .item {
      width: 100%;
      height: 96px;
      padding: 0 33px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #f1f1f1;
      .wx {
        img {
          width: 42px;
          height: 37px;
          margin-right: 15px;
          float: left;
        }
      }
      .zfb {
        img {
          width: 38px;
          height: 38px;
          margin-right: 15px;
          float: left;
        }
      }

      /deep/.van-radio__icon--checked .van-icon {
        background: linear-gradient(to right, #fc4d1d, #cf1104);
        border-color: transparent;
      }
      div {
        font-size: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        .color-js {
          color: #ff1919;
        }
      }
      .color-js {
        color: #ff1919;
      }
    }
  }
  .pay {
    width: 100%;
    height: 94px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 40px;
    margin-top: 20px;
    p {
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      span {
        color: #ff1919;
        font-size: 30px;
      }
    }
    button {
      width: 217px;
      height: 74px;
      text-align: center;
      line-height: 74px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      background: linear-gradient(
        270deg,
        rgba(205, 15, 2, 1) 0%,
        rgba(229, 47, 35, 1) 60%,
        rgba(255, 81, 28, 1) 100%
      );
      border-radius: 37px;
    }
  }
}
</style>


